import styled from 'styled-components/native';
import {HeightProps, WidthProps, height, width} from 'styled-system';

export interface StyledImageProps extends HeightProps, WidthProps {}

export const StyledImage = styled.Image<StyledImageProps>`
  ${height}
  ${width}
`;
